import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import EventChangePages from '../components/event/EventChangePages';
import '../css/style.css';
import '../components/Home.css';
import { translate } from "react-i18next";
import { EDIT_URL } from '../backend/Backend';
import Sharing from "../components/util/Sharing";
import { Form, Row, Col } from 'react-bootstrap';

class EventChangeLayout extends Component {

    render() {
        const { t } = this.props;
        const { params } = this.props.match
        var splitted = params.id.split("-", 2);
        let url = EDIT_URL + params.id;
        return (<SimpleLayout title={t("ereignisbearbeiten")} eventKey="3">
            <div>
                <EventChangePages preURL="events/invited" id={params.id} />
                <hr className="mt-5 " />
                <Row>
                    <Col lg={3} className=" mt-1" >
                       <a href={`${url}`} data-href={`${url}DATA`} role="link" tabindex="1" target="_blank" data-channel="twitter"   >
                       <i className="text-primary fa fa-globe s16  mr-2" ></i>{t("goTpPrivateEvent")}</a>
                    </Col>
                  
                    <Col lg={9} className=" float-left">
                    <Form.Label className="mt-1 float-left">{t("share")}&nbsp;</Form.Label>
                        <Sharing url={EDIT_URL + splitted[0] + "-" + splitted[1]} title={t("eventPartLink")} />
                    </Col>

              
                    
                  
                </Row>
            </div>

        </SimpleLayout>)
    }

}


export default translate("translations")(EventChangeLayout);